<template>
  <div class="loader-wrapper" v-if="visible">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: true
    }
  }
};
</script>

<style scoped>
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--my-semi-dark);
  opacity: 0.8;
  z-index: 1000;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid var(--my-border);
  border-top: 5px solid var(--my-links);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
